import { render, staticRenderFns } from "./ContentFeedReviews.vue?vue&type=template&id=68271602&scoped=true&"
import script from "./ContentFeedReviews.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedReviews.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedReviews.vue?vue&type=style&index=0&id=68271602&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68271602",
  null
  
)

export default component.exports